var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/surgeon.0b8f1b2c.png","uri@2x": __webpack_public_path__ + "static/media/surgeon.08f977c3.png","uri@3x": __webpack_public_path__ + "static/media/surgeon.247237ac.png",
    width: 50,
    height: 50
});